import { render, staticRenderFns } from "./KelasOfflineEdit.vue?vue&type=template&id=32ba36b8&scoped=true"
import script from "./KelasOfflineEdit.vue?vue&type=script&lang=js"
export * from "./KelasOfflineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba36b8",
  null
  
)

export default component.exports